import { combineReducers } from 'redux';

import { reducer as autenticacao } from './autentication';

export default combineReducers({
    autenticacao,
});
